import clsx from 'clsx';
import React from 'react';
import classes from './CommonCard.module.css';
export default function CommonCard({ children, Tag = 'div', className, ...rest }) {
  return (
    <Tag className={clsx(classes.wrapper, className)} {...rest}>
      {children}
    </Tag>
  );
}
